<template>
  <div class="backStack-issue-wrap informationCreate">
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel"
    >
    </From>
    <div class="backStack-issue-footer-wrap">
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="toAudit(2)">保存</a-button>
        <a-button class="submit-audit" @click="toAudit(0)">保存并发布</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/mixins/backStack'
import mixinConfigSetting from '@/mixins/mixinConfigSetting'
import { formRules, formRows } from './configs/formOptions.js'
import { policyDocumentDetail, editPolicyDocument } from '@/api/InformationNote'

export default {
  mixins: [mixinsBackStack, mixinConfigSetting],
  data() {
    return {
      loading: true,
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {},
      isRead: false,
      detailId: null
    }
  },
  components: {
    From
  },
  created() {
    this.initSetting()
  },
  methods: {
    // 初始化数据
    initSetting() {
      const { id } = this.$route.query
      this.detailId = id
      this.initDefaultModel()
    },
    // 页面初始化带数据
    async initDefaultModel() {
      const { data } = await policyDocumentDetail(this.detailId)
      console.log(data, 'data')
      let { typeId, ...otherParam } = data
      typeId = String(typeId)
      this.defaultModel = {
        ...otherParam,
        typeId
      }
    },
    // 后台文件编辑更新
    async toAudit(status) {
      this.$refs.formRef.validatedForm(async () => {
        try {
          let { appendix, ...formValue } = this.$refs.formRef.formModel
          appendix = this.handlerAnnexIds(appendix).join(',')
          const params = {
            ...formValue,
            status,
            appendix,
            id: this.detailId,
            typeId: '2',
            code: 'policy',
          }
          const { msg, code } = await editPolicyDocument(params)
          this.$apiStatusHandler(code, msg)
          if (code === 200) {
            this.$router.push({ name: 'contentPolicyDocumentNote', query: { type: 'contentPolicyDocumentNote' } })
          }
        } catch (error) {
          this.$apiStatusHandler(99, error)
        }
      })
    },
    handlerAnnexIds(annexIds) {
      if (!annexIds) return []
      return annexIds.reduce((pre, item) => {
        let fileId
        if (item.id) {
          fileId = item.id
        }
        if (item.response) {
          fileId = item.response[0].fileId
        }
        pre.push(fileId)
        return pre
      }, [])
    },
    handlerPicPathIds(picPath) {
      if (!picPath) return []
      return picPath.reduce((pre, item) => {
        let fileId
        if (item.id) {
          fileId = item.id
        }
        if (item.response) {
          fileId = item.response[0].fileId
        }
        pre.push(fileId)
        return pre
      }, [])
    }
  }
}
</script>
